import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from 'components/PageHeader';
import PageFooter from 'components/PageFooter';
import TermsModal from 'components/TermsModal';
import { termsAndConditionsContent } from './termsContent';
import { trackEvent } from 'services/firebase';
import {
  HeroSection,
  KeyInformationSection,
  AwardCategoriesSection,
  TimelinePrizesSection,
  WinnerSection,
} from './components';
import { useAuth } from 'contexts/AuthContext';

const AwardHome: React.FC = () => {
  const { isAuthenticated } = useAuth();

  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent('page_view', {
      page_title: 'SMDD Award Home',
      page_path: '/smdd-award-home',
    });
  }, []);

  const handleRegisterClick = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    const isAcknowledged = localStorage.getItem('isAcknowledge') === 'true';
    if (isAcknowledged) {
      navigate('/smdd-form');
    } else {
      setShowTermsModal(true);
    }
  };

  const handleTermsAccept = () => {
    localStorage.setItem('isAcknowledge', 'true');
    setShowTermsModal(false);
    navigate('/smdd-form');
  };

  const handleTermsClose = () => {
    setShowTermsModal(false);
  };

  return (
    <div className="min-h-screen bg-white text-smdd-black">
      {/* Skip link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:bg-smdd-red focus:text-white focus:px-4 focus:py-2 focus:rounded"
      >
        Skip to main content
      </a>

      <PageHeader />

      <HeroSection onRegisterClick={handleRegisterClick} />

      <KeyInformationSection />

      <AwardCategoriesSection />

      {isAuthenticated() && <WinnerSection />}

      <TimelinePrizesSection />

      <PageFooter />

      <TermsModal
        isOpen={showTermsModal}
        onClose={handleTermsClose}
        onAccept={handleTermsAccept}
        termsContent={termsAndConditionsContent}
      />
    </div>
  );
};

export default AwardHome;
